import {useState} from "react";
import s from './Checkbox.module.scss';
import {CheckMarkIcon} from "@/app/[locale]/common/assets/CheckMarkIcon/CheckMarkIcon";
import {TCheckboxProps} from "@/app/[locale]/common/components/Checkbox/types";

export const Checkbox = ({ handleCheckBoxChange }: TCheckboxProps) => {
    const [ checked, setChecked ] = useState<boolean>(false);
    const onClick = () => {
        setChecked(!checked);
        handleCheckBoxChange(!checked);
    };

    return (
        <div className={`${s.checkbox} ${checked ? s.checkbox_checked : ''}`} onClick={onClick}>
            { checked && <CheckMarkIcon /> }
        </div>
    );
};